/* ============================================================================
   Big Z's starter kits (2026-10-23): Starter + Premium on the product page.
   ZZ, Oct 23: "Make the starter kit collapsible, more fun, a starter kit + starter kit premium,
   smart adjusting to each product. Group slings, scorplings, then anything 2in+. The millipedes
   always shoot for 2-3x enclosures." Premium (ZZ's picks, same day): the Starter's box plus
   extras; botanicals by climate; springtails + dwarf white isopods for humid setups and millipedes.

   Groups   sling      tarantula or true spider under 2 in of leg span
            scorpling  scorpion under 2 in long
            small      any other fella under 2 in
            millipede  every millipede, any size
            big        2 in and up
   Fit      leg span   box rated (bigzs.max_leg_span_in) >= the fella: tarantulas, true spiders,
                       whip spiders; the Buddy lane its care guide names first, then any ground box
            length     floor's long side >= 2x body length (centipedes, vinegaroons and the rest;
                       ZZ confirmed "for now", Oct 23). Ground scorpions (terrestrial or fossorial,
                       scorplings too) need 3x (ZZ, Oct 26: "Scorpions terrestrial should have 3x floor
                       length for the move in kit"). floorX on the fella carries the multiple.
            bark scorp climbing scorpions fit the Bark Buddy at any size (ZZ, for the Arizona bark;
                       the Florida bark follows the same rule, as in the builder)
            millipede  floor's long side 2x to 3x its length and at least 1x wide (ZZ, and the
                       care guide's "two body lengths long and one wide")
            Spice 4-5  locking acrylic only; nothing in stock that fits means a message, not a kit
   Starter  box, substrate sized to the box, cork bark, a shot of moss (not for bone-dry fellas),
            catch cup (Spice 4-5). ZZ, Oct 31: "the starter kit just make shot of moss, cork bark,
            the appropriate substrate, the appropriate enclosure." The extra small water dish moved
            to Premium, bigger boxes only (8 x 5 floor and up); millipede leaf litter moved to Premium.
   Premium  the same box + cork tube (when the box holds one) + botanicals by climate (humid and
            millipedes: leaf litter, casuarina cones; desert and semi-arid: cholla wood; climbers:
            spiderwood branch; slings and scorplings: mini bell cups) + springtails and dwarf white
            isopods (humid setups and millipedes)
   Millipedes  no Big Z mix at all (ZZ: no coco fiber for millipedes; every mix but Desert Burrow has
            it). The kit shows a "Flake soil, coming soon" line instead: Big Z is sourcing flake soil.
   Price    the kit total rounds down to the nearest .99 (ZZ), but only when the automatic Dry Goods
            discount already takes the checkout price at or under that number; the note gives the
            checkout figure. Wholesale logins and kits under 3 dry goods show the plain sum.
   Sold-out pieces drop out with a note. There is never a button that does nothing.
   Data: snippets/bz-habitat-addon.liquid ([data-bzk-data]). Helpers: window.BZP.rules
   (assets/bz-pathways.js). The home quick add still picks boxes by leg span (the 2026-10-21 rules).
   The builder uses this file's millipede box rule (pickMilli there) and the same millipede substrate
   rule (no mix, flake soil coming). A vial kit says to vent the lid (the flip-top cups come vented).
   2026-10-31 (kit audit, ZZ): counts like "All 3" are not sizes; spiders listed by body length go to
   Size it with Big Z; packs and pairs of solitary animals get "One home per fella"; a guide's
   "No Buddy" no longer blocks a kit (every Big Z acrylic hard-locks with magnets), only listings
   marked custom stay custom; millipede boxes need substrate as deep as the animal is long; mixed
   wet/dry guides are settled by humidity; humid clean-up crew only for humid setups; 3 in+ fellas get
   the Cork Bark Tube as their hide; 4 in+ fellas on big floors get the Medium dish; depth warning from
   the care guide; diggers measured by length start in the Burrow lane; adult beetles skip the cups.
   Kits are switched off per product with the no-starter-kit tag (snippets/bz-habitat-addon).
   Later on Oct 31 (ZZ): Starter trimmed to box, substrate, cork bark and moss; the Medium dish is gone.
   Backup of the 2026-10-23 version: assets/bz-backup-2026-10-31-kit.js.
   ========================================================================== */
(function () {
  'use strict';
  if (window.BZK) return;
  var BZK = window.BZK = { version: '2026-10-31' };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var low = function (s) { return String(s == null ? '' : s).toLowerCase(); };
  var num = function (n) { return String(Math.round(n * 100) / 100); };
  var NOUN = { tarantula: 'tarantula', spider: 'spider', scorpion: 'scorpion', centipede: 'centipede', millipede: 'millipede', other: 'fella' };
  var SHORT = {
    'cork-bark-tube': 'a cork bark tube', 'mini-bell-cups': 'mini bell cup hides', 'casuarina-cones': 'casuarina cones',
    'spiderwood-branch': 'a spiderwood branch', 'tropical-leaf-litter-mix': 'leaf litter', 'cholla-wood': 'cholla wood',
    'repti-zoo-water-dish': 'a water dish'
  };
  var CREW = { 'temperate-springtail-master-culture-with-clay': 'springtails', 'dwarf-white-isopods-10-count-trichorhina-tomentosa': 'isopods' };

  /* ---------- the fella ------------------------------------------------------ */
  function kindOf(p) {
    var t = low(p.type), ti = low(p.title);
    if (t === 'millipede' || /millipede/.test(ti)) return 'millipede';
    if (t === 'tarantula') return 'tarantula';
    if (t === 'spider' || /tailless whip|whip ?spider|amblypyg/.test(ti)) return 'spider';
    if (t === 'scorpion' || (/scorpion/.test(ti) && !/whip scorpion/.test(ti))) return 'scorpion';
    if (t === 'centipede' || /centipede/.test(ti)) return 'centipede';
    return 'other';
  }
  // Upper bound of the listed size in inches. Counts ("10 Count", "Pair") are not sizes. No size on
  // the listing: an instar is a tiny sling, otherwise plan for the adult size in the care guide.
  function sizeOf(R, vTitle, adult) {
    // 2026-10-31 (kit audit): "All 3", "4 Animals" and "5 Beetles" are counts too, not sizes.
    var t = String(vTitle || '').replace(/\b\d+\s*(count|ct|pack|pcs?|pieces)\b/ig, ' ')
      .replace(/\ball\s+\d+\b/ig, ' ')
      .replace(/\b\d+\s+(animals?|beetles?|slings?|fellas?|scorpions?)\b/ig, ' ');
    var s = R.parseSize(t);
    if (s != null) return { L: s, from: 'listing' };
    if (/\bi\s?\d+\b|instar/i.test(t)) return { L: 0.5, from: 'instar' };
    s = adult ? R.parseSize(String(adult)) : null;
    return s != null ? { L: s, from: 'adult' } : { L: null, from: null };
  }
  function groupOf(kind, L, vTitle) {
    if (kind === 'millipede') return 'millipede';
    var baby = L != null ? L < 2 : /sling|scorpling|instar|nymph|baby/i.test(vTitle || '');
    if (!baby) return 'big';
    return kind === 'tarantula' || kind === 'spider' ? 'sling' : kind === 'scorpion' ? 'scorpling' : 'small';
  }
  // The guide's substrate line decides; humidity only breaks the tie (same order as BZP.rules).
  function mixKey(g) {
    var sub = low(g && g.substrate), hum = low(g && g.humidity);
    // 2026-10-31 (kit audit): a guide that mentions wet and dry ("dry soil, one moist corner") is
    // settled by its humidity range, not by whichever word the pattern meets first.
    var hm = hum.match(/(\d+)\s*-\s*(\d+)\s*%/), lo = hm ? +hm[1] : null, hi = hm ? +hm[2] : null;
    if (/sand|desert|bone-dry|bone dry/.test(sub)) return 'desert-burrow-mix';
    var wet = /moist|humid|damp below|tropical|leaf|humus|rotting|rotten/.test(sub), dry = /dry|semi-arid|arid/.test(sub);
    if (wet && dry && hi != null) return hi <= 60 ? 'semi-arid-mix' : lo >= 65 ? 'tropical-burrow-mix' : 'multipurpose-mix';
    if (wet) return 'tropical-burrow-mix';
    if (dry) return lo != null && lo >= 65 && /damp/.test(sub) ? 'tropical-burrow-mix' : 'semi-arid-mix';
    if (/7\d-9\d%|8\d%/.test(hum)) return 'tropical-burrow-mix';
    return 'multipurpose-mix';
  }
  function ctxOf(R, data, vid) {
    var p = data.product || {}, g = data.guide || {};
    var vs = p.variants || [];
    var v = vs.find(function (x) { return String(x.vid) === String(vid); }) || vs[0] || {};
    var kind = kindOf(p);
    var sz = sizeOf(R, v.title, g.adult_size);
    // 2026-10-31 (kit audit): a spider listed by body length has no leg span to match a box to.
    // Jumping spiders keep their kits (the box is right for them either way).
    if ((kind === 'tarantula' || kind === 'spider') && /\bbody\b/i.test(v.title || '') && !/leg span/i.test(v.title || '') && !/jump/i.test((p.title || '') + ' ' + (p.handle || ''))) sz = { L: null, from: 'body' };
    var group = groupOf(kind, sz.L, v.title);
    var ln = R.laneOf(data, R.stageOf(v.title, p.size_stage, sz.L));
    var tags = (p.tags || []).map(low);
    var arb = kind !== 'millipede' && (ln.lane === 'bark' || tags.indexOf('arboreal') > -1 || tags.indexOf('climber') > -1);
    var key = mixKey(g);
    return {
      v: v, kind: kind, L: sz.L, from: sz.from, group: group, lane: ln.lane, why: ln.why, arb: arb,
      deep: kind === 'millipede' || ln.lane === 'burrow' || tags.indexOf('fossorial') > -1 || /burrow/.test(low(g.setup_type)),
      measure: kind === 'tarantula' || kind === 'spider' ? 'dls' : kind === 'millipede' ? 'milli' : 'len',
      spice: +p.spice || 0, mix: kind === 'millipede' ? 'flake-soil' : key,
      climate: key === 'desert-burrow-mix' ? 'desert' : key === 'semi-arid-mix' ? 'semi' : 'humid',
      multi: /pair|\bcount\b|colony|group|trio|\bpack\b|\ball \d+\b|\b\d+\s+animals\b/i.test((v.title || '') + ' ' + (p.title || '')),
      // 2026-10-31 (kit audit): solitary animals. A listing with more than one never shares a kit box.
      solo: kind === 'tarantula' || kind === 'spider' || kind === 'scorpion' || kind === 'centipede',
      // Bark scorpions (climbing scorpions) live in the Bark Buddy at any size (ZZ, Oct 23: "AZ bark is
      // good in bark buddy"), the same as the builder's rule; the 2x length rule doesn't apply to it.
      barkScorp: kind === 'scorpion' && arb,
      // Floor rule: 3x body length for ground scorpions (ZZ, Oct 26), 2x for everything else on the length rule.
      floorX: kind === 'scorpion' && !arb ? 3 : 2,
      adult: g.adult_size || ''
    };
  }

  /* ---------- the box ---------------------------------------------------------- */
  function geo(R, title) {
    if (/dram|vial/i.test(title)) return { w: 1, d: 1, h: 2, floor: 0.8, kind: 'cup', lock: false };
    var g = R.geometry({ title: title });
    if (g.kind === 'cup' && !g.w) { var s = Math.sqrt(g.floor); g.w = s; g.d = s; }
    return g;
  }
  function boxesOf(R, data) {
    var by = {};
    (data.enclosures || []).forEach(function (e) {
      var b = by[e.h];
      if (!b) {
        var g = geo(R, e.t || '');
        b = by[e.h] = { handle: e.h, title: e.t, vid: e.v, price: +e.p, available: !!e.a, max: e.m == null ? null : +e.m, img: e.i, url: e.u,
          w: g.w, d: g.d, h: g.h, floor: g.floor, kind: g.kind, lock: !!g.lock, lanes: {}, climb: /arboreal|bark buddy/i.test(e.t || '') };
        b.long = Math.max(b.w, b.d); b.wide = Math.min(b.w, b.d);
      }
      var c = e.c;
      b.lanes[c === 'burrow' ? 'burrow' : (c === 'bark' || c === 'arboreal') ? 'bark' : c === 'containers' ? 'cup' : c === 'baby' ? 'baby' : (b.climb ? 'bark' : 'ground')] = true;
    });
    return Object.keys(by).map(function (k) { return by[k]; });
  }
  function pickBox(all, c) {
    // 2026-10-31 (kit audit): more than one solitary animal gets "one home per fella".
    if (c.multi && c.solo) return { state: 'perfella' };
    // A listing marked custom (habitat fit "custom") stays custom.
    if (c.lane === 'none' && /marked as a custom setup/i.test(c.why || '')) return { state: 'custom', why: c.why };
    if (c.L == null) return { state: 'size' };
    // A care guide that says "No Buddy" no longer blocks a kit: every Big Z acrylic hard-locks with
    // magnets (ZZ, Oct 31; the Panama wandering spider lives great in the 3 x 3 x 3), so the fella gets
    // the best locking box for its size. Only a spider nothing has been matched to stays custom.
    if (c.measure === 'dls' && c.lane === 'none' && !/No Buddy/i.test(c.why || '')) return { state: 'custom', why: c.why };
    var L = c.L;
    var ok = all.filter(function (b) {
      if (c.spice >= 4 && !b.lock) return false;
      // 2026-10-31: adult beetles and other 1 in+ fellas skip the cups too.
      if ((c.group === 'big' || c.group === 'millipede' || (c.kind === 'other' && c.L >= 1)) && b.kind === 'cup') return false;
      return c.arb ? b.climb : !b.climb;
    });
    var fits = function (b) {
      if (c.measure === 'dls') return b.max != null && b.max >= L;
      // 2026-10-31 (kit audit): and substrate at least as deep as it is long, with an inch of air.
      if (c.measure === 'milli') return b.long >= 2 * L && b.wide >= L && b.h - 1 >= L;
      if (c.barkScorp && /bark buddy/i.test(b.title || '')) return true;
      return b.long >= c.floorX * L;
    };
    var best = function (list) {
      var f = list.filter(fits);
      if (!f.length) return null;
      if (c.measure === 'milli') { var inR = f.filter(function (b) { return b.long <= 3 * L + 0.01; }); if (inR.length) f = inR; }
      f.sort(function (x, y) { return (x.price - y.price) || (c.deep ? y.h - x.h : x.floor - y.floor); });
      return f[0];
    };
    // 2026-10-31 (kit audit): diggers measured by length (centipedes, vinegaroons) start in the Burrow
    // lane, so a 2 in vinegaroon gets the 4 x 4 x 4 Burrow Buddy instead of a 3 in tall box.
    var digPool = c.measure === 'len' && c.deep && c.group === 'big' && c.kind !== 'scorpion' ? ok.filter(function (b) { return b.lanes.burrow; }) : ok;
    var lanePool = c.measure !== 'dls' ? digPool : ok.filter(function (b) {
      if (c.lane === 'baby') return b.lanes.baby || b.lanes.cup;
      if (c.lane === 'burrow') return b.lanes.burrow;
      return true;
    });
    var stocked = function (l) { return l.filter(function (b) { return b.available; }); };
    var box = best(stocked(lanePool)) || best(stocked(ok));
    if (box) return { state: 'ok', box: box };
    var gone = best(lanePool) || best(ok);
    return gone ? { state: 'soldout', box: gone } : { state: 'custom' };
  }

  /* ---------- the kit ------------------------------------------------------------ */
  // Substrate sized to the box: floor x fill depth / 57.75 cu in per quart. Quart bags for whole
  // quarts, quarter bags for a small remainder, never more bags than are on the shelf.
  function substrate(data, c, box) {
    var m = (data.supplies || {})[c.mix];
    if (!m) return { none: true };
    var depth = box.kind === 'cup' ? box.h * 0.5
      : c.kind === 'millipede' ? Math.min(box.h - 1, Math.max(box.h * 2 / 3, c.L || 0))
      : c.arb ? 1 : c.deep ? box.h * 2 / 3 : box.h * 0.5;
    var qts = box.floor * depth / 57.75;
    var vs = m.variants || [];
    var q1 = vs.find(function (v) { return /^1 qt/i.test(v.title); }), q4 = vs.find(function (v) { return /1\/4/.test(v.title); });
    var has = function (v) { return v && v.available ? (v.stock == null ? 999 : Math.max(0, +v.stock)) : 0; };
    var a1 = has(q1), a4 = has(q4);
    var n1 = Math.floor(qts), rem = qts - n1, n4 = 0;
    if (rem > 0.5) n1 += 1; else if (rem > 0.001) n4 = Math.ceil(rem / 0.25);
    if (!n1 && !n4) n4 = 1;
    if (n1 > a1) { var miss = n1 - a1; n1 = a1; if (miss === 1 && a4 >= n4 + 4) n4 += 4; }
    if (n4 > a4) { if (n4 <= 2 && a1 > n1) { n1 += 1; n4 = 0; } else n4 = a4; }
    var lines = [];
    if (n1) lines.push({ id: q1.vid, n: n1, handle: c.mix, label: m.title + ', 1 qt' + (n1 > 1 ? ' × ' + n1 : ''), price: q1.price * n1, img: m.img, why: 'Substrate' });
    if (n4) lines.push({ id: q4.vid, n: n4, handle: c.mix, label: m.title + ', 1/4 qt' + (n4 > 1 ? ' × ' + n4 : ''), price: q4.price * n4, img: m.img, why: 'Substrate' });
    var got = n1 + n4 / 4;
    return { title: m.title, lines: lines, qts: qts, got: got, short: got + 0.01 < qts };
  }
  function buildKit(data, c, box, all) {
    var S = [], X = [], warn = [], out = {};
    var sup = function (h, re) {
      var a = (data.supplies || {})[h];
      if (!a) return null;
      var vs = a.variants || [];
      var v = (re && vs.find(function (x) { return re.test(x.title) && x.available; })) || vs.find(function (x) { return x.available; });
      if (!v) { out[h] = a.title; return null; }
      return { id: v.vid, n: 1, handle: h, label: a.title + (vs.length > 1 ? ', ' + String(v.title).replace(/ bag$/i, '') : ''), price: +v.price, img: a.img };
    };
    var add = function (list, it, why) { if (it) { it.why = why; if (CREW[it.handle]) it.crew = true; list.push(it); } return it; };
    var baby = c.group === 'sling' || c.group === 'scorpling' || c.group === 'small';
    // 2026-10-31: humid clean-up crew only for humid setups (dry-country millipedes like Orthoporus get none).
    var humid = c.climate === 'humid';
    var minSide = Math.min(box.w || 0, box.d || 0);
    S.push({ id: box.vid, n: 1, handle: box.handle, label: box.title, price: box.price, img: box.img, why: 'Home, sized to fit' });
    var sub = c.kind === 'millipede' ? { lines: [] } : substrate(data, c, box);
    if (c.kind === 'millipede') S.push({ soon: true, id: null, n: 0, handle: 'flake-soil', label: 'Flake soil', price: 0, img: null, why: 'Substrate, coming soon' });
    else if (sub.none) warn.push('The substrate this fella needs is sold out right now. Message Big Z.');
    else {
      sub.lines.forEach(function (l) { S.push(l); });
      if (sub.short) warn.push('This box takes about ' + Math.ceil(sub.qts) + ' qt of ' + sub.title + '. ' + num(sub.got) + ' qt ' + (sub.got === 1 ? 'is' : 'are') + ' on the shelf, so the kit adds ' + num(sub.got) + '. Message Big Z for the rest.');
    }
    // 2026-10-31 (ZZ): the Starter is the enclosure, the substrate, cork bark and a shot of moss. Nothing
    // else (no dish, no coconut hide, no leaf litter); the catch cup stays for Spice 4-5.
    // Cork bark: the Cork Bark Tube for a 3 in+ fella when the box holds one, else the small cork piece.
    var bigHide = (c.L || 0) >= 3 && box.kind !== 'cup' && minSide >= 4 && box.h >= (c.arb ? 6 : 5);
    var hide = bigHide ? add(S, sup('cork-bark-tube'), 'Cork bark') : null;
    if (!hide) add(S, sup('extra-cork-bark-hide-buddy-add-on'), 'Cork bark');
    // A shot of moss for a damp corner, except for a fella its care guide keeps bone dry with no misting.
    var gtxt = low(((data.guide || {}).substrate || '') + ' ' + ((data.guide || {}).humidity || ''));
    var bone = /bone[- ]dry|no misting|no wet corner/.test(gtxt) && !/damp corner|moist corner|damp refuge|damp retreat/.test(gtxt);
    var moss = bone ? null : add(S, sup('shot-of-moss'), 'Moss');
    if (c.kind === 'millipede') warn.push('Millipedes live in and eat their substrate. We’re working on sourcing flake soil, so it isn’t in the kit yet. Message Big Z before your millipede ships.');
    if (c.spice >= 4) {
      var cup = all.find(function (b) { return b.handle === '24-oz-flip-top-plastic-enclosure' && b.available; });
      if (cup) S.push({ id: cup.vid, n: 1, handle: cup.handle, label: cup.title, price: cup.price, img: cup.img, why: 'Catch cup' });
      else warn.push('The catch cup is sold out right now. A Spice ' + c.spice + ' fella needs one before it arrives. Message Big Z.');
    }
    // Premium: the same box, plus extras (ZZ, 2026-10-23).
    // 2026-10-31 (ZZ): the water dish moves here, Extra Small only ("the medium is HUGE"), and only in the
    // bigger boxes it fits (an 8 x 5 floor and up).
    var dishRoom = !baby && box.kind !== 'cup' && box.floor >= 40;
    var dish = dishRoom ? add(X, sup('repti-zoo-water-dish', /extra small/i), 'Water dish') : null;
    if (!hide && box.kind !== 'cup' && minSide >= 4 && box.h >= (c.arb ? 6 : 5)) add(X, sup('cork-bark-tube'), 'Bigger hide');
    if (baby) { if (box.floor >= 7) add(X, sup('mini-bell-cups'), 'Botanical hides'); }
    else if (c.kind === 'millipede') { add(X, sup('tropical-leaf-litter-mix'), 'Food and cover'); add(X, sup('casuarina-cones'), 'Botanicals'); }
    else if (c.arb) { if (box.h >= 6) add(X, sup('spiderwood-branch'), 'Climbing branch'); if (humid) add(X, sup('tropical-leaf-litter-mix'), 'Leaf litter'); }
    else if (humid) { add(X, sup('tropical-leaf-litter-mix'), 'Leaf litter'); add(X, sup('casuarina-cones'), 'Botanicals'); }
    else if (minSide >= 4) add(X, sup('cholla-wood'), 'Desert wood');
    if (humid) {
      add(X, sup('temperate-springtail-master-culture-with-clay'), 'Clean-up crew');
      if (box.kind !== 'cup' || box.floor >= 20) add(X, sup('dwarf-white-isopods-10-count-trichorhina-tomentosa'), 'Clean-up crew');
    }
    return { S: S, X: X, warn: warn, bone: bone, moss: !!moss, dish: dish ? 'yes' : dishRoom ? 'out' : 'no' };
  }

  /* ---------- words ---------------------------------------------------------------- */
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function list(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  // Kit price: the sum rounded down to the nearest .99 (ZZ), shown only when the automatic Dry Goods
  // discount (per unit, fraction of a cent dropped, as Shopify does) already brings the checkout price
  // to that number or under. Clean-up crews don't count as dry goods here.
  function priceOf(items, b2b) {
    var sum = 0, dq = 0, off = 0;
    items.forEach(function (i) { if (i.soon) return; sum += i.price; if (!i.crew) dq += i.n; });
    var pct = b2b ? 0 : dq >= 12 ? 0.2 : dq >= 6 ? 0.15 : dq >= 3 ? 0.1 : 0;
    if (pct) items.forEach(function (i) { if (!i.soon && !i.crew && i.n) off += Math.floor((i.price / i.n) * pct) * i.n; });
    var pay = sum - off, r = Math.floor((sum + 1) / 100) * 100 - 1;
    return { sum: sum, pay: pay, pct: pct, dq: dq, show: pct && r > 0 && r >= pay ? r : sum };
  }
  function heads(c) {
    var L = c.L != null ? num(c.L) : '';
    var t, s;
    if (c.group === 'sling') { t = 'Sling starter'; s = 'Tiny fella, tiny apartment. Sized to its ' + L + ' in leg span.'; }
    else if (c.group === 'scorpling') { t = 'Scorpling starter'; s = 'Snug and escape-proof for a ' + L + ' in scorpling.'; }
    else if (c.group === 'small') { t = 'Little fella starter'; s = 'Snug and escape-proof for a ' + L + ' in ' + NOUN[c.kind] + '.'; }
    else if (c.group === 'millipede') { t = 'Millipede move-in kit'; s = 'A floor 2 to 3x its length. Flake soil is on the way.'; }
    else if (c.measure === 'dls') { t = cap(NOUN[c.kind]) + ' move-in kit'; s = 'Sized to ' + L + ' in of leg span, set up the way its care guide says.'; }
    else if (c.barkScorp) { t = 'Bark scorpion move-in kit'; s = 'A tall home for a ' + L + ' in climber.'; }
    else { t = c.kind === 'other' ? 'Move-in kit' : cap(NOUN[c.kind]) + ' move-in kit'; s = 'Floor at least ' + c.floorX + 'x its ' + L + ' in length.'; }
    if (c.spice >= 4) s = 'Locking lid and catch cup in every kit. Hands stay out.';
    return { t: t, s: s };
  }
  function fitLine(c, box) {
    var L = num(c.L), dims = box.kind === 'cup' ? 'About ' + num(box.long) + ' in across' : 'Floor ' + num(box.w) + ' x ' + num(box.d) + ' in';
    var tail = c.from === 'adult' ? ' Mixed-size listing, so it is sized for the adult (' + c.adult + ').' : '';
    if (c.measure === 'dls') return 'Rated for up to ' + num(box.max) + ' in of leg span. This fella: ' + L + ' in.' + tail;
    if (c.measure === 'milli') return dims + ': ' + num(Math.round(box.long / c.L * 10) / 10) + 'x its ' + L + ' in length. Big Z aims for 2 to 3x.' + tail;
    if (c.barkScorp && /bark buddy/i.test(box.title || '')) return 'Bark Buddy: Big Z’s pick for bark scorpions. They climb, so height matters more than floor.' + tail;
    return dims + ': at least ' + c.floorX + 'x a ' + L + ' in ' + (c.group === 'scorpling' ? 'scorpling' : NOUN[c.kind]) + '.' + tail;
  }
  function pitch(items, extras) {
    if (extras) {
      var bits = [], crew = [];
      extras.forEach(function (i) { if (CREW[i.handle]) crew.push(CREW[i.handle]); else if (SHORT[i.handle]) bits.push(SHORT[i.handle]); });
      if (crew.length) bits.push((crew.length > 1 ? 'a springtail and isopod' : crew[0] === 'isopods' ? 'an isopod' : 'a springtail') + ' clean-up crew');
      return 'Everything in Starter, plus ' + list(bits) + '. Same box, more life.';
    }
    var w = [];
    items.forEach(function (i) { if (i.soon) return; var x = low(i.why); if (x && w.indexOf(x) < 0) w.push(x === 'home, sized to fit' ? 'a home sized to fit' : x === 'hide' ? 'a hide' : x === 'moss' ? 'a shot of moss' : x === 'water dish' ? 'a water dish' : x === 'catch cup' ? 'a catch cup' : x === 'food and cover' ? 'leaf litter' : x); });
    return 'The must-haves: ' + list(w) + '.';
  }

  /* ---------- page ---------------------------------------------------------------- */
  // Kit above Add to Cart, Frequently paired below it (ZZ, 2026-10-23). The visual order is CSS
  // (snippets/bz-pdp-simple); this puts the DOM in the same order so the Tab key agrees.
  function place(root) {
    var buy = root.closest('.bz-product-buy'); if (!buy) return;
    buy.classList.add('bzk-on');
    var form = buy.querySelector('form.bz-product-form'); if (!form) return;
    var qty = form.querySelector(':scope > .bz-product-qty');
    if (qty && !form.contains(root)) form.insertBefore(root, qty);
    var pair = form.querySelector(':scope > .bz-product-pairing');
    var after = form.querySelector(':scope > .bz-product-wishlist-link') || form.querySelector(':scope > .bz-product-submit');
    if (pair && after) after.after(pair);
  }
  function init(root, R) {
    var q = function (s) { return root.querySelector(s); };
    var card = q('[data-bzk-card]'), dataEl = q('[data-bzk-data]');
    if (!card || !dataEl) return;
    var el = { toggle: q('[data-bzk-toggle]'), inner: q('[data-bzk-inner]'), title: q('[data-bzk-title]'), sub: q('[data-bzk-sub]'), from: q('[data-bzk-from]'), from2: q('[data-bzk-from2]'),
      tiers: q('[data-bzk-tiers]'), pitch: q('[data-bzk-pitch]'), list: q('[data-bzk-list]'), fit: q('[data-bzk-fit]'), notes: q('[data-bzk-notes]'), add: q('[data-bzk-add]'), more: q('[data-bzk-more]'), photo: q('[data-bzk-photo]') };
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var S = { tier: 'starter', kit: null, open: false };
    function setOpen(o) {
      S.open = o;
      if (o) card.setAttribute('data-open', ''); else card.removeAttribute('data-open');
      el.toggle.setAttribute('aria-expanded', String(o));
      el.inner.inert = !o; el.inner.setAttribute('aria-hidden', String(!o));
    }
    el.toggle.addEventListener('click', function () {
      setOpen(!S.open);
      if (S.open && window.clarity) { try { window.clarity('set', 'bz_kit', 'opened'); } catch (_) { } }
    });
    place(root);
    if (!R) { markBare(true); el.sub.textContent = 'Put one together in the builder.'; el.more.hidden = false; return; }
    var all = boxesOf(R, data);
    var money = function (c) { return R.money(c, data.money_format); };
    var contact = '/pages/contact';
    var builder = (data.builder_url || '/pages/build-your-habitat') + '?fella=' + encodeURIComponent(data.product.handle);
    function more(href, label) { el.more.href = href; el.more.innerHTML = esc(label) + ' &rarr;'; el.more.hidden = false; }
    // 2026-10-25 (ZZ): "Frequently paired" steps aside whenever a Move-in kit is offered. CSS hides it
    // from the first paint (snippets/bz-pdp-simple); .bzk-bare brings it back when no kit can be built.
    function markBare(on) {
      var buyEl = root.closest('.bz-product-buy');
      if (buyEl) buyEl.classList.toggle('bzk-bare', !!on);
    }
    function bare(title, sub, text, href, label) {
      S.kit = null;
      markBare(true);
      el.title.textContent = title; el.sub.textContent = sub; el.from.textContent = ''; el.from2.textContent = '';
      el.tiers.hidden = true; el.list.hidden = true; el.fit.hidden = true; el.add.hidden = true;
      el.pitch.textContent = text; el.notes.innerHTML = '';
      more(href, label);
    }
    function selectedVariant() {
      var input = document.querySelector('#bz-product-form [name="id"], form[action*="/cart/add"] [name="id"]');
      var fromUrl = null; try { fromUrl = new URL(window.location.href).searchParams.get('variant'); } catch (_) { }
      return (input && input.value) || fromUrl || data.product.selected;
    }
    function row(i, plus) {
      if (i.soon) return '<li class="bzk-li" style="opacity:.78"><span class="bzk-ph" aria-hidden="true"></span><span>' + esc(i.label) + '<small>' + esc(i.why) + '</small></span><span>Soon</span></li>';
      return '<li class="bzk-li">' + (i.img ? '<img src="' + esc(i.img) + '" alt="" width="36" height="36" loading="lazy">' : '<span class="bzk-ph" aria-hidden="true"></span>') +
        '<span>' + (plus ? '<span class="bzk-plus">Premium</span>' : '') + esc(i.label) + (i.why ? '<small>' + esc(i.why) + '</small>' : '') + '</span><span>' + money(i.price) + '</span></li>';
    }
    function renderTier() {
      var k = S.kit; if (!k) return;
      var prem = S.tier === 'premium' && k.X.length > 0;
      var items = prem ? k.S.concat(k.X) : k.S, pr = prem ? k.pP : k.pS, buy = items.filter(function (i) { return !i.soon; });
      [].forEach.call(el.tiers.querySelectorAll('[data-bzk-tier]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-bzk-tier') === (prem ? 'premium' : 'starter'))); });
      el.pitch.textContent = prem ? pitch(k.S, k.X) : pitch(k.S);
      el.list.innerHTML = k.S.map(function (i) { return row(i); }).join('') + (prem ? k.X.map(function (i) { return row(i, true); }).join('') : '');
      var notes = k.notes.slice();
      if (pr.pct) notes.push({ t: 'Dry Goods ' + (pr.dq >= 12 ? '12+' : pr.dq >= 6 ? '6+' : '3+') + ' takes ' + Math.round(pr.pct * 100) + '% off each piece at checkout, so this kit comes to about ' + money(pr.pay) + '.' });
      el.notes.innerHTML = notes.map(function (n) { return '<p' + (n.warn ? ' class="is-warn"' : '') + '>' + esc(n.t) + '</p>'; }).join('');
      el.add.textContent = 'Add ' + (prem ? 'Premium' : 'Starter') + ' kit · ' + money(pr.show);
      el.add.setAttribute('aria-label', 'Add the ' + (prem ? 'Premium' : 'Starter') + ' kit, ' + buy.length + ' items, ' + money(pr.show));
      el.add._items = buy.map(function (i) { return { id: i.id, quantity: i.n, handle: i.handle }; });
      el.add._names = buy.map(function (i) { return i.label; });
      el.add._tier = prem ? 'premium' : 'starter';
    }
    function render() {
      var c = ctxOf(R, data, selectedVariant());
      var pk = pickBox(all, c);
      // 2026-10-31 (ZZ): the kit badge is a photo of the sling kit with this fella's substrate bag
      // (assets/bz-kit-<mix>.jpg, from ZZ's "Easy sling kit" photos). Millipedes show the Multipurpose one.
      var photos = data.kit_photos || {}, ph = photos[c.mix] || photos['multipurpose-mix'];
      if (el.photo && ph && el.photo.getAttribute('src') !== ph) el.photo.setAttribute('src', ph);
      el.list.hidden = false; el.fit.hidden = false; el.add.hidden = false; el.add.classList.remove('is-done');
      // 2026-10-31 (kit audit): more than one solitary fella in one listing, and spiders listed by body length.
      if (pk.state === 'perfella') return bare('One home per fella', 'Each animal in this listing needs its own enclosure.', 'Tarantulas, true spiders, scorpions and centipedes live alone. Message Big Z and we’ll kit out every fella in this listing.', contact, 'Message Big Z');
      if (pk.state === 'size' && c.from === 'body') return bare('Size it with Big Z', 'Listed by body length, so we fit the home to its leg span.', 'This listing gives a body length, and our enclosures are rated by leg span. Message Big Z and we’ll match the enclosure to your fella.', contact, 'Message Big Z');
      if (pk.state === 'size') return bare('Size it with Big Z', 'Mixed sizes, so we fit the home to the fella you get.', 'This listing has no set size, so the kit can’t pick a box yet. Tell Big Z which one you’re after and we’ll match the enclosure.', c.measure === 'dls' ? builder : contact, c.measure === 'dls' ? 'Pick in the builder' : 'Message Big Z');
      if (pk.state === 'custom') return bare('Custom setup', c.L ? 'Bigger than our acrylic line at ' + num(c.L) + ' in.' : 'This fella needs a custom home.', (c.spice >= 4 ? 'A Spice ' + c.spice + ' fella needs a locking acrylic enclosure, and none in our line fits this size. ' : (pk.why ? pk.why + ' ' : '')) + 'Message Big Z and we’ll plan the enclosure with you.', contact, 'Message Big Z');
      if (pk.state === 'soldout') return bare('Fitted box sold out', 'The ' + pk.box.title + ' fits, and it’s out right now.', 'Check back soon, or message Big Z and we’ll find another way to house it.', pk.box.url || contact, pk.box.url ? 'See the box' : 'Message Big Z');
      var box = pk.box, k = buildKit(data, c, box, all), h = heads(c), notes = [];
      // 2026-10-31 (ZZ): no dish in the Starter. The water note follows the fella and the box.
      var corner = k.moss ? 'the moss corner' : 'one corner';
      if (k.bone) notes.push({ t: 'Kept bone dry, so no moss. Water it the way its care guide says.' });
      else if (k.dish === 'yes') notes.push({ t: c.kind === 'millipede' ? 'Premium adds an extra small water dish. Fill it with pebbles before your millipede moves in.' : 'Premium adds an extra small water dish. With the Starter, keep ' + corner + ' damp.' });
      else if (k.dish === 'out') notes.push({ t: 'The water dish is sold out right now. Keep ' + corner + ' damp until it is back.', warn: 1 });
      else notes.push({ t: c.arb ? 'No water dish at this size. Mist a few drops on the web or the wall.' : 'No water dish at this size. It drinks from ' + (k.moss ? 'the damp moss corner.' : 'a damp corner.') });
      if (c.kind === 'millipede' && c.L > box.h - 1) notes.push({ t: 'Care guide: substrate at least as deep as it is long. This box is ' + num(box.h) + ' in tall, so plan a deeper home as it grows.', warn: 1 });
      // 2026-10-31 (kit audit): diggers whose care guide asks for more depth than this box holds.
      var needIn = (function () { var m = String((data.guide || {}).substrate || '').match(/(\d+(?:\.\d+)?)(?:\s*-\s*\d+(?:\.\d+)?)?\s*in\b\+?/i); return m ? +m[1] : null; })();
      if (needIn && c.deep && c.group === 'big' && c.kind !== 'millipede' && box.kind !== 'cup' && box.h * 2 / 3 + 0.01 < needIn) notes.push({ t: 'Care guide: about ' + num(needIn) + ' in of substrate. This box holds about ' + num(Math.round(box.h * 2 / 3 * 10) / 10) + ' in, so pack it deep and plan a taller home as it grows.', warn: 1 });
      // The flip-top cups come vented; the 7 dram vial does not (its listing: vent the lid before housing anything live).
      if (/dram|vial/i.test(box.title || '')) notes.push({ t: 'Vent the vial lid with a pin or hot needle before your fella moves in.', warn: 1 });
      if (c.multi && !c.solo) notes.push({ t: 'More than one fella? Groups need more floor, so size up.', warn: 1 });
      if (c.spice >= 4) notes.push({ t: 'Spice ' + c.spice + ' kits include a catch cup for rehousing and maintenance, so your hands stay out.' });
      k.warn.forEach(function (w) { notes.push({ t: w, warn: 1 }); });
      S.kit = { S: k.S, X: k.X, pS: priceOf(k.S, data.b2b), pP: priceOf(k.S.concat(k.X), data.b2b), notes: notes };
      markBare(false);
      el.title.textContent = h.t; el.sub.textContent = h.s;
      el.from.textContent = money(S.kit.pS.show);
      el.from2.textContent = k.X.length ? 'Premium ' + money(S.kit.pP.show) : '';
      el.tiers.hidden = !k.X.length;
      el.tiers.querySelector('[data-bzk-tp="starter"]').textContent = money(S.kit.pS.show);
      el.tiers.querySelector('[data-bzk-tp="premium"]').textContent = money(S.kit.pP.show);
      if (!k.X.length) S.tier = 'starter';
      el.fit.textContent = fitLine(c, box);
      if (c.measure === 'dls') more(builder, 'Customize in the builder'); else more(contact, 'Questions? Message Big Z');
      renderTier();
    }
    el.tiers.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-bzk-tier]'); if (!b) return;
      S.tier = b.getAttribute('data-bzk-tier'); renderTier();
    });
    el.add.addEventListener('click', function () {
      var btn = el.add;
      if (!btn._items || !btn._items.length || btn.classList.contains('is-busy')) return;
      var label = btn.textContent, tier = btn._tier, items = btn._items.slice(), names = (btn._names || []).slice();
      var add = function (lines) { return window.BZP && window.BZP.addItems ? window.BZP.addItems(lines) : Promise.reject(new Error('Could not add. Try again.')); };
      // BZP.toast writes HTML, except a message without a link goes to the inventory guard's toast, which writes plain text.
      var say = function (msg, link) {
        if (!window.BZP || !window.BZP.toast) return;
        var plain = !link && window.bzInventoryGuard && typeof window.bzInventoryGuard.showToast === 'function';
        window.BZP.toast(plain ? msg : esc(msg), link);
      };
      var old = el.notes && el.notes.querySelector('[data-bzk-skipped]');
      if (old) old.remove();
      btn.classList.add('is-busy');
      // Shopify adds a kit all or nothing. When it refuses (a 4xx such as 422: one piece this login can't buy,
      // like a retail-only line on a wholesale account, or one that just sold out), add the pieces one at a time
      // and name the ones that didn't go in, instead of failing the whole kit (ZZ, Oct 24: wholesale logins should
      // get kits too). Busy or connection errors (409, 429, 5xx, offline) are never retried here, so nothing can
      // land in the bag twice; if one stops the one-at-a-time pass midway, the message says to check the bag first.
      var soft = function (e) { return !!e && e.status >= 400 && e.status < 500 && e.status !== 409 && e.status !== 429; };
      add(items).then(function () { return []; }, function (err) {
        if (!soft(err) || err.partialCartAdd || items.length < 2) throw err;
        var skipped = [], added = 0;
        return items.reduce(function (p, it, i) {
          return p.then(function () {
            return add([it]).then(function () { added++; }, function (e) {
              if (soft(e)) { skipped.push(names[i] || 'One piece'); return; }
              if (!added) throw e;
              var part = new Error('Part of the kit is in your bag. Check your bag before adding again.');
              part.toCart = true;
              throw part;
            });
          });
        }, Promise.resolve()).then(function () {
          if (!added) throw err;
          return skipped;
        });
      }).then(function (skipped) {
        btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.textContent = '✓ In your bag';
        var kit = (tier === 'premium' ? 'Premium' : 'Starter') + ' kit added';
        if (skipped.length) {
          var miss = 'Added everything except ' + list(skipped) + '. Message Big Z if you need ' + (skipped.length > 1 ? 'them' : 'it') + '.';
          if (el.notes) el.notes.insertAdjacentHTML('afterbegin', '<p class="is-warn" data-bzk-skipped>' + esc(miss) + '</p>');
          say(kit + ', except ' + list(skipped), { href: '/cart', label: 'View cart' });
        } else say(kit, { href: '/cart', label: 'View cart' });
        if (window.clarity) { try { window.clarity('set', 'bz_kit', tier + (skipped.length ? '_added_partial' : '_added')); } catch (_) { } }
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 2600);
      }).catch(function (err) {
        btn.classList.remove('is-busy');
        say((err && err.message) || 'Could not add. Try again.', err && err.toCart ? { href: '/cart', label: 'View cart' } : undefined);
      });
    });
    setOpen(false);
    render();
    var last = selectedVariant();
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') setTimeout(function () { last = selectedVariant(); render(); }, 0); });
    setInterval(function () { var now = selectedVariant(); if (now !== last) { last = now; render(); } }, 700);
  }

  BZK.rules = { kindOf: kindOf, sizeOf: sizeOf, groupOf: groupOf, mixKey: mixKey, ctxOf: ctxOf, boxesOf: boxesOf, pickBox: pickBox, substrate: substrate, buildKit: buildKit, heads: heads, fitLine: fitLine, pitch: pitch, priceOf: priceOf };
  var tries = 0;
  function boot() {
    var R = window.BZP && window.BZP.rules;
    if (!R && tries++ < 100) { setTimeout(boot, 50); return; }
    document.querySelectorAll('[data-bzk]').forEach(function (root) { if (!root._bzk) { root._bzk = 1; init(root, R || null); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
